import React, { useState, useEffect } from 'react'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'

import styles from './TaskHeaderErrors.module.sass'

const TaskHeaderErrors = (props) => {
	const { errors, onClick } = props
	const [displayIndex, setDisplayIndex] = useState(0)
	const currentError = errors ? errors[displayIndex] : null

	useEffect(() => {
		if (!currentError && errors && errors.length > 0) {
			setDisplayIndex(0)
		}
	}, [currentError, errors])

	return errors && errors.length ? (
		<label className={styles['errors-container']} error='true'>
			{currentError && (
				<small onClick={onClick} className={styles['error-message']}>
					<Icon
						className={styles['error-icon']}
						width='16px'
						height='16px'
						name='warning'
					/>
					{currentError}
				</small>
			)}
			<small
				className={styles['counter']}
				onClick={() => {
					setDisplayIndex(
						displayIndex === errors.length - 1
							? 0
							: displayIndex + 1
					)
				}}
			>
				{displayIndex + 1}/{errors.length}
			</small>
		</label>
	) : null
}

export default TaskHeaderErrors
